import {
   Box,
   Flex,
   useColorModeValue,
   Avatar,
   Text,
   Badge,
   HStack,
   IconButton,
   Button,
   Menu,
   MenuButton,
   MenuList,
   MenuItem,
   useDisclosure,
   Modal,
   ModalOverlay,
   ModalContent,
   ModalHeader,
   ModalCloseButton,
   ModalBody,
   ModalFooter,
   Spacer,
   Divider,
   Grid,
   GridItem,
   Checkbox,
   Input,
   useColorMode,
} from '@chakra-ui/react';
import { EditIcon, DeleteIcon, CopyIcon, SettingsIcon, InfoIcon } from '@chakra-ui/icons';
import React, { useEffect, useState, useRef } from 'react';
import { CiMenuKebab, CiPhone } from 'react-icons/ci';
import { useSelector, useDispatch } from 'react-redux';
import DeleteDialog from 'views/admin/masters/components/DeleteDialog';
import { Link } from 'react-router-dom';
import { IoMdArrowRoundBack } from 'react-icons/io';
import moment from 'moment';
import {
   addPrintFormat,
   deletePrintFormat,
   getPrintFormat,
   getPrintFormatById,
} from '../../../../redux/actions/customizeprintings';
import { addSetupFormat, deleteSetupFormat } from '../../../../redux/actions/setupFormat';
import { renderDynamicDropdown } from 'components/UIcomponents/DynamicDropdown';
import { getDaybook } from '../../../../redux/actions/daybook';
import { functionNameOptions } from 'constants';
import { DynamicInput } from 'components/UIcomponents/Dynamicinput';
import { useGlobal, useUser } from '../../../../contexts';

export default function PrintSetting(props) {
   const { colorMode } = useColorMode();
   const isDark = colorMode === 'dark';

   const [isDeleteDialogOpen, setDeleteDialogOpen] = React.useState(false);
   const [isDeleteSetupDialogOpen, setDeleteSetupDialogOpen] = React.useState(false);
   const [isModalOpen, setIsModalOpen] = React.useState(false);
   const [newName, setNewName] = React.useState('');
   const [error, setError] = useState('');
   const printFormatData = useSelector((state) => state.customizeprintings?.single);
   const backgroundColor = useColorModeValue('white', '#101F4A');
   const textColor = useColorModeValue('secondaryGray.900', 'white');
   const [row, setRow] = useState({
      id: null,
      functionName: '',
      companyId: '',
      daybookId: '',
      printId: '',
      isDefault: false,
   });
   const [viewSetupFormat, setViewSetupFormat] = useState({});
   const functionNames = functionNameOptions.map((company) => ({
      value: company.value,
      label: company.label,
      id: company.value,
      name: company.label,
   }));

   const [errors, setErrors] = useState({});
   const companyList = useSelector((state) => state.company.list || []);

   const dispatch = useDispatch();
   const list = useSelector((state) => state.customizeprintings?.list);
   const daybookData = useSelector((state) => state.daybook?.list);
   const user = useSelector((state) => state.user?.profile);

   const { userGlobalSettingsData } = useGlobal();
   const shouldSendCompanyidDaybook = userGlobalSettingsData?.[0]?.askCompany?.daybook || false;

   const {
      isOpen: isSetupFormatModalOpen,
      onOpen: onOpenSetupFormatModal,
      onClose: onCloseSetupFormatModal,
   } = useDisclosure();
   const {
      isOpen: isViewSetupFormatModalOpen,
      onOpen: onViewOpenSetupFormatModal,
      onClose: onViewCloseSetupFormatModal,
   } = useDisclosure();

   const handleInputChange = (field, value) => {
      setRow((prev) => ({
         ...prev,
         [field]: value,
      }));

      setErrors((prevErrors) => {
         const newErrors = { ...prevErrors };
         if (newErrors[field]) {
            delete newErrors[field];
         }
         return newErrors;
      });
   };

   const clearFormData = () => {
      setRow({
         id: null,
         functionName: '',
         companyId: '',
         daybookId: '',
         printId: '',
         isDefault: false,
      });
      setErrors({});
   };

   const handleDuplicateClick = async (id) => {
      dispatch(getPrintFormatById(id));
      setIsModalOpen(true);
   };

   const handleSaveDuplicate = () => {
      if (newName.trim() === '') {
         setError('Name is required.');
         return;
      }
      if (!printFormatData) return;
      const updatedName = newName.trim() !== '' ? newName : printFormatData.Name;
      const newEntry = {
         ...printFormatData,
         Name: updatedName,
         id: undefined,
         setupFormats: [],
      };
      delete newEntry.id;
      delete newEntry.dbName;
      delete newEntry.functionName;
      delete newEntry.css;
      delete newEntry.createdBy;
      delete newEntry.createdAt;
      delete newEntry.status;
      delete newEntry.updatedAt;
      delete newEntry.updatedBy;
      delete newEntry.setupFormats;

      dispatch(addPrintFormat(newEntry));
      setIsModalOpen(false);
      setNewName('');
   };

   useEffect(() => {
      const fetchData = async () => {
         try {
            await dispatch(getPrintFormat());
         } catch (error) {
            console.error('Error fetching data:', error);
         }
      };

      fetchData();
   }, [dispatch]);

   useEffect(() => {
      if (isSetupFormatModalOpen) {
         dispatch(
            getDaybook({
               companyId: user?.loginhistory?.companyId,
               ...(shouldSendCompanyidDaybook && { companyIds: user?.loginhistory?.companyId }),
            }),
         );
      }
   }, [isSetupFormatModalOpen, dispatch, user]);

   const [isShareToCompanyModalOpen, setIsShareToCompanyModalOpen] = useState(false);

   const handleCloseShareToCompanyModal = () => {
      setIsShareToCompanyModalOpen(false);
   };

   const [selectedRowId, setSelectedRowId] = useState(null);
   const [selectedSetupRowId, setSelectedSetupRowId] = useState(null);
   const [data, setData] = useState([]);

   const handleDelete = async (member) => {
      setSelectedRowId(member.id);
      setDeleteDialogOpen(true);
   };

   const handleSetupDelete = async (id) => {
      setSelectedSetupRowId(id);
      setDeleteSetupDialogOpen(true);
   };

   const handleConfirmDelete = async () => {
      if (selectedRowId !== null) {
         try {
            await dispatch(deletePrintFormat(selectedRowId));
            setData(data?.filter((row) => row.id !== selectedRowId));
            setDeleteDialogOpen(false);
         } catch (err) {}
      }
   };

   const handleConfirmSetupDelete = async () => {
      if (selectedSetupRowId !== null) {
         try {
            await dispatch(deleteSetupFormat(selectedSetupRowId));
            setDeleteSetupDialogOpen(false);
            await dispatch(getPrintFormat());
         } catch (err) {}
      }
   };

   const scrollContainerRef = useRef(null);

   useEffect(() => {
      const handleScroll = (e) => {};

      const scrollContainer = scrollContainerRef.current;
      if (scrollContainer) {
         scrollContainer.addEventListener('scroll', handleScroll);
      }

      return () => {
         if (scrollContainer) {
            scrollContainer.removeEventListener('scroll', handleScroll);
         }
      };
   }, []);

   const handleSaveSetupFormat = async (row) => {
      try {
         await dispatch(addSetupFormat(row));
         await dispatch(getPrintFormat());
         clearFormData();
         onCloseSetupFormatModal();
      } catch (error) {
         console.error('Failed to save setup format:', error);
      }
   };

   return (
      <>
         <div className={`min-h-[95vh] max-h-[95vh] overflow-y-auto ${isDark ? 'bg-gray-900' : 'bg-gray-50'}`}>
            <div className="p-6">
               {/* Header Section */}
               <div className="flex items-center gap-4 mb-8 mt-8">
                  <Link to="/admin/setting">
                     <button
                        className={`p-3 rounded-xl transition-all duration-200 hover:scale-105 ${
                           isDark
                              ? 'bg-slate-800 hover:bg-slate-700 text-white border border-slate-700'
                              : 'bg-white hover:bg-gray-50 text-gray-700 border border-gray-200 shadow-sm'
                        }`}>
                        <IoMdArrowRoundBack size={20} />
                     </button>
                  </Link>
                  <div>
                     <h1
                        className={`text-3xl font-bold bg-gradient-to-r ${
                           isDark ? 'from-blue-400 to-purple-400' : 'from-blue-600 to-purple-600'
                        } bg-clip-text text-transparent`}>
                        Print Settings
                     </h1>
                     <p className={`text-sm mt-1 ${isDark ? 'text-gray-400' : 'text-gray-500'}`}>
                        Manage your print formats and configurations
                     </p>
                  </div>
               </div>

               {/* Company Print Settings Section */}
               <div className="mb-10">
                  <div className={`inline-flex items-center gap-3 mb-6 `}>
                     <div className={`w-1 h-8 ${isDark ? 'bg-blue-400' : 'bg-blue-600'}`}></div>
                     <h2 className={`text-xl font-bold ${isDark ? 'text-blue-300' : 'text-blue-900'}`}>
                        Company Print Settings
                     </h2>
                  </div>

                  <div className="flex flex-wrap gap-6">
                     {list?.map((member, index) => {
                        if (member.dbName === null) {
                           return (
                              <div
                                 key={index}
                                 className={`group relative w-full sm:w-full md:w-[330px] lg:w-[330px] xl:w-[360px] rounded-xl transition-all duration-300 ${
                                    isDark
                                       ? 'bg-gradient-to-br from-slate-800 to-slate-900 border-2 border-slate-700 hover:border-blue-500/50'
                                       : 'bg-white border-2 border-gray-200 hover:border-blue-300 shadow-md'
                                 }`}>
                                 <div className="p-5">
                                    <div className="flex items-start gap-4 mb-4">
                                       <div
                                          className={`relative ${
                                             isDark ? 'ring-2 ring-blue-500/30' : 'ring-2 ring-blue-200'
                                          } rounded-full`}>
                                          <Avatar name={member.name} src={member.avatar} size="md" />
                                       </div>

                                       <div className="flex-1 min-w-0">
                                          <h3
                                             className={`font-bold text-base mb-1 truncate ${
                                                isDark ? 'text-white' : 'text-gray-900'
                                             }`}>
                                             {member.Name}
                                          </h3>
                                          {member.phone && (
                                             <div
                                                className={`flex items-center gap-2 text-sm ${
                                                   isDark ? 'text-gray-400' : 'text-gray-600'
                                                }`}>
                                                <CiPhone className="flex-shrink-0" />
                                                <span className="truncate">{member.phone}</span>
                                             </div>
                                          )}
                                       </div>

                                       <Menu>
                                          <MenuButton
                                             as={IconButton}
                                             icon={<CiMenuKebab />}
                                             size="sm"
                                             variant="ghost"
                                             className={`flex-shrink-0 ${
                                                isDark
                                                   ? 'hover:bg-slate-700 text-gray-300'
                                                   : 'hover:bg-gray-100 text-gray-600'
                                             }`}
                                          />
                                          <MenuList
                                             zIndex={9999}
                                             bg={isDark ? '#1e293b' : 'white'}
                                             borderColor={isDark ? '#334155' : '#e2e8f0'}
                                             boxShadow="lg"
                                             minW="180px">
                                             <MenuItem
                                                icon={<CopyIcon />}
                                                isDisabled={member?.isAdmin}
                                                onClick={() => handleDuplicateClick(member.id)}
                                                bg={isDark ? '#1e293b' : 'white'}
                                                _hover={{ bg: isDark ? '#334155' : '#f7fafc' }}
                                                color={isDark ? 'white' : 'gray.800'}>
                                                Duplicate
                                             </MenuItem>
                                             <MenuItem
                                                icon={<SettingsIcon />}
                                                onClick={() => {
                                                   onOpenSetupFormatModal();
                                                   setRow({ printId: member.id });
                                                }}
                                                isDisabled={member?.isAdmin}
                                                bg={isDark ? '#1e293b' : 'white'}
                                                _hover={{ bg: isDark ? '#334155' : '#f7fafc' }}
                                                color={isDark ? 'white' : 'gray.800'}>
                                                Setup Format
                                             </MenuItem>
                                             <MenuItem
                                                icon={<InfoIcon />}
                                                onClick={() => {
                                                   onViewOpenSetupFormatModal();
                                                   setViewSetupFormat(member.setupFormats);
                                                }}
                                                isDisabled={member?.isAdmin}
                                                bg={isDark ? '#1e293b' : 'white'}
                                                _hover={{ bg: isDark ? '#334155' : '#f7fafc' }}
                                                color={isDark ? 'white' : 'gray.800'}>
                                                View Setup Format
                                             </MenuItem>
                                          </MenuList>
                                       </Menu>
                                    </div>

                                    <div
                                       className={`h-px mb-4 ${
                                          isDark
                                             ? 'bg-gradient-to-r from-transparent via-slate-700 to-transparent'
                                             : 'bg-gradient-to-r from-transparent via-gray-200 to-transparent'
                                       }`}></div>

                                    <div className="flex items-center justify-between">
                                       <Link to={`/admin/setting/print-settings/view/${member.id}`}>
                                          <span
                                             className={`inline-flex items-center gap-2 px-4 py-1.5 rounded-xl text-sm font-medium transition-all duration-200 hover:scale-105 ${
                                                member?.isAdmin
                                                   ? isDark
                                                      ? 'bg-green-500/20 text-green-300 border border-green-500/30'
                                                      : 'bg-green-50 text-green-700 border border-green-200'
                                                   : isDark
                                                   ? 'bg-purple-500/20 text-purple-300 border border-purple-500/30'
                                                   : 'bg-purple-50 text-purple-700 border border-purple-200'
                                             }`}>
                                             <svg
                                                className="w-4 h-4"
                                                fill="none"
                                                stroke="currentColor"
                                                viewBox="0 0 24 24">
                                                <path
                                                   strokeLinecap="round"
                                                   strokeLinejoin="round"
                                                   strokeWidth={2}
                                                   d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                                                />
                                                <path
                                                   strokeLinecap="round"
                                                   strokeLinejoin="round"
                                                   strokeWidth={2}
                                                   d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
                                                />
                                             </svg>
                                             Preview
                                          </span>
                                       </Link>
                                       {member.createdAt && (
                                          <span
                                             className={`text-xs flex items-center gap-1 ${
                                                isDark ? 'text-gray-500' : 'text-gray-400'
                                             }`}>
                                             <svg
                                                className="w-3.5 h-3.5"
                                                fill="none"
                                                stroke="currentColor"
                                                viewBox="0 0 24 24">
                                                <path
                                                   strokeLinecap="round"
                                                   strokeLinejoin="round"
                                                   strokeWidth={2}
                                                   d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
                                                />
                                             </svg>
                                             {moment(member.createdAt).format('DD/MM/YYYY')}
                                          </span>
                                       )}
                                    </div>
                                 </div>
                              </div>
                           );
                        }
                        return null;
                     })}
                  </div>
               </div>

               {/* My Print Settings Section */}
               <div>
                  <div className={`inline-flex items-center gap-3 mb-6`}>
                     <div className={`w-1 h-8  ${isDark ? 'bg-purple-400' : 'bg-purple-600'}`}></div>
                     <h2 className={`text-xl font-bold ${isDark ? 'text-purple-300' : 'text-purple-900'}`}>
                        My Print Settings
                     </h2>
                  </div>

                  <div className="flex flex-wrap gap-6">
                     {list?.map((member, index) => {
                        if (member.id !== user?.id && member.dbName !== null) {
                           return (
                              <div
                                 key={index}
                                 className={`group relative w-full sm:w-full md:w-[330px] lg:w-[330px] xl:w-[360px] rounded-xl transition-all duration-300${
                                    isDark
                                       ? 'bg-gradient-to-br from-slate-800 to-slate-900 border-2 border-slate-700 hover:border-purple-500/50'
                                       : 'bg-white border-2 border-gray-200 hover:border-purple-300 shadow-md'
                                 }`}>
                                 <div className="p-5">
                                    <div className="flex items-start gap-4 mb-4">
                                       <div
                                          className={`relative ${
                                             isDark ? 'ring-2 ring-purple-500/30' : 'ring-2 ring-purple-200'
                                          } rounded-full`}>
                                          <Avatar name={member.name} src={member.avatar} size="md" />
                                       </div>

                                       <div className="flex-1 min-w-0">
                                          <h3
                                             className={`font-bold text-base mb-1 truncate ${
                                                isDark ? 'text-white' : 'text-gray-900'
                                             }`}>
                                             {member.Name}
                                          </h3>
                                          {member.phone && (
                                             <div
                                                className={`flex items-center gap-2 text-sm ${
                                                   isDark ? 'text-gray-400' : 'text-gray-600'
                                                }`}>
                                                <CiPhone className="flex-shrink-0" />
                                                <span className="truncate">{member.phone}</span>
                                             </div>
                                          )}
                                       </div>

                                       <Menu>
                                          <MenuButton
                                             as={IconButton}
                                             icon={<CiMenuKebab />}
                                             size="sm"
                                             variant="ghost"
                                             className={`${
                                                isDark
                                                   ? 'hover:bg-slate-700 text-gray-300'
                                                   : 'hover:bg-gray-100 text-gray-600'
                                             }`}
                                          />
                                          <MenuList className={isDark ? 'bg-slate-800 border-slate-700' : 'bg-white'}>
                                             <MenuItem
                                                icon={<CopyIcon />}
                                                isDisabled={member?.isAdmin}
                                                onClick={() => handleDuplicateClick(member.id)}
                                                className={isDark ? 'hover:bg-slate-700' : 'hover:bg-gray-50'}>
                                                Duplicate
                                             </MenuItem>
                                             <Link to={`/admin/setting/print-settings/edit/${member.id}`}>
                                                <MenuItem
                                                   icon={<EditIcon />}
                                                   isDisabled={member?.isAdmin}
                                                   className={isDark ? 'hover:bg-slate-700' : 'hover:bg-gray-50'}>
                                                   Edit
                                                </MenuItem>
                                             </Link>
                                             <MenuItem
                                                icon={<DeleteIcon />}
                                                onClick={() => handleDelete(member)}
                                                isDisabled={member?.isAdmin}
                                                className={isDark ? 'hover:bg-slate-700' : 'hover:bg-gray-50'}>
                                                Delete
                                             </MenuItem>
                                             <MenuItem
                                                icon={<SettingsIcon />}
                                                onClick={() => {
                                                   onOpenSetupFormatModal();
                                                   setRow({ printId: member.id });
                                                }}
                                                isDisabled={member?.isAdmin}
                                                className={isDark ? 'hover:bg-slate-700' : 'hover:bg-gray-50'}>
                                                Setup Format
                                             </MenuItem>
                                             <MenuItem
                                                icon={<InfoIcon />}
                                                onClick={() => {
                                                   onViewOpenSetupFormatModal();
                                                   setViewSetupFormat(member.setupFormats);
                                                }}
                                                isDisabled={member?.isAdmin}
                                                className={isDark ? 'hover:bg-slate-700' : 'hover:bg-gray-50'}>
                                                View Setup Format
                                             </MenuItem>
                                          </MenuList>
                                       </Menu>
                                    </div>

                                    <div
                                       className={`h-px mb-4 ${
                                          isDark
                                             ? 'bg-gradient-to-r from-transparent via-slate-700 to-transparent'
                                             : 'bg-gradient-to-r from-transparent via-gray-200 to-transparent'
                                       }`}></div>

                                    <div className="flex items-center justify-between">
                                       <Link to={`/admin/setting/print-settings/view/${member.id}`}>
                                          <span
                                             className={`inline-flex items-center gap-2 px-4 py-1.5 rounded-xl text-sm font-medium transition-all duration-200 hover:scale-105 ${
                                                member?.isAdmin
                                                   ? isDark
                                                      ? 'bg-green-500/20 text-green-300 border border-green-500/30'
                                                      : 'bg-green-50 text-green-700 border border-green-200'
                                                   : isDark
                                                   ? 'bg-purple-500/20 text-purple-300 border border-purple-500/30'
                                                   : 'bg-purple-50 text-purple-700 border border-purple-200'
                                             }`}>
                                             <svg
                                                className="w-4 h-4"
                                                fill="none"
                                                stroke="currentColor"
                                                viewBox="0 0 24 24">
                                                <path
                                                   strokeLinecap="round"
                                                   strokeLinejoin="round"
                                                   strokeWidth={2}
                                                   d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                                                />
                                                <path
                                                   strokeLinecap="round"
                                                   strokeLinejoin="round"
                                                   strokeWidth={2}
                                                   d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
                                                />
                                             </svg>
                                             Preview
                                          </span>
                                       </Link>
                                       {member.createdAt && (
                                          <span
                                             className={`text-xs flex items-center gap-1 ${
                                                isDark ? 'text-gray-500' : 'text-gray-400'
                                             }`}>
                                             <svg
                                                className="w-3.5 h-3.5"
                                                fill="none"
                                                stroke="currentColor"
                                                viewBox="0 0 24 24">
                                                <path
                                                   strokeLinecap="round"
                                                   strokeLinejoin="round"
                                                   strokeWidth={2}
                                                   d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
                                                />
                                             </svg>
                                             {moment(member.createdAt).format('DD/MM/YYYY')}
                                          </span>
                                       )}
                                    </div>
                                 </div>
                              </div>
                           );
                        }
                        return null;
                     })}
                  </div>
               </div>
            </div>

            <Modal isOpen={isSetupFormatModalOpen} onClose={onCloseSetupFormatModal} isCentered size="xl">
               <ModalOverlay />
               <ModalContent>
                  <ModalHeader>Setup Format</ModalHeader>
                  <ModalCloseButton />
                  <ModalBody>
                     <Grid
                        templateColumns={{ base: 'repeat(1, 1fr)', md: 'repeat(3, 1fr)', xl: 'repeat(3, 1fr)' }}
                        gap={2}>
                        <GridItem className="seperator-width">
                           {renderDynamicDropdown(
                              'functionName',
                              'Function Name',
                              functionNames,
                              {
                                 value: row.functionName,
                                 onChange: (value) => handleInputChange('functionName', value),
                              },
                              errors,
                              textColor,
                              false,
                              'Select Function Name',
                           )}
                        </GridItem>
                        <GridItem className="seperator-width">
                           {renderDynamicDropdown(
                              'daybookId',
                              'Daybook',
                              (() => {
                                 if (['Sales Invoice'].includes(row.functionName)) {
                                    return daybookData.filter((d) => d.type === 5);
                                 } else if (['Sales Return', 'Credit Notes'].includes(row.functionName)) {
                                    return daybookData.filter((d) => d.type === 6);
                                 } else if (['Purchase Invoices'].includes(row.functionName)) {
                                    return daybookData.filter((d) => d.type === 11);
                                 } else if (['Purchase Returns', 'Debit Notes'].includes(row.functionName)) {
                                    return daybookData.filter((d) => d.type === 12);
                                 } else if (['Cash Payments', 'Cash Receipts'].includes(row.functionName)) {
                                    return daybookData.filter((d) => d.type === 13);
                                 } else if (['Bank Payment', 'Bank Receipt'].includes(row.functionName)) {
                                    return daybookData.filter((d) => d.type === 14);
                                 } else if (['Journal Voucher'].includes(row.functionName)) {
                                    return daybookData.filter((d) => d.type === 18);
                                 } else if (['Inventory Issues'].includes(row.functionName)) {
                                    return daybookData.filter((d) => d.type === 19);
                                 } else if (['Inventory Receipts'].includes(row.functionName)) {
                                    return daybookData.filter((d) => d.type === 20);
                                 } else {
                                    return daybookData;
                                 }
                              })(),
                              {
                                 value: row.daybookId,
                                 onChange: (value) => handleInputChange('daybookId', value),
                              },
                              errors,
                              textColor,
                              false,
                              'Select Daybook',
                           )}
                        </GridItem>
                        <GridItem className="seperator-width">
                           {renderDynamicDropdown(
                              'companyId',
                              'Company',
                              companyList,
                              {
                                 value: row.companyId,
                                 onChange: (value) => handleInputChange('companyId', value),
                                 showCustomNoOptions: true,
                              },
                              errors,
                              textColor,
                              false,
                              'Select Compony',
                           )}
                        </GridItem>
                        <GridItem className="seperator-width">
                           {DynamicInput(
                              'printerName',
                              'Printer Name',
                              {
                                 value: row.printerName,
                                 onChange: (e) => handleInputChange('printerName', e.target.value),
                              },
                              errors,
                              textColor,
                              'text',
                              false,
                           )}
                        </GridItem>
                        <Checkbox
                           isChecked={row.isDefault}
                           onChange={(e) => handleInputChange('isDefault', e.target.checked)}>
                           Set Default
                        </Checkbox>
                     </Grid>
                  </ModalBody>
                  <ModalFooter>
                     <Button colorScheme="gray" mr={3} onClick={onCloseSetupFormatModal}>
                        Cancel
                     </Button>
                     <Button colorScheme="green" variant="solid" onClick={() => handleSaveSetupFormat(row)}>
                        Save Changes
                     </Button>
                  </ModalFooter>
               </ModalContent>
            </Modal>

            <Modal
               isOpen={isViewSetupFormatModalOpen}
               onClose={() => {
                  onViewCloseSetupFormatModal();
                  setViewSetupFormat({});
               }}
               size="xl">
               <ModalOverlay />
               <ModalContent>
                  <ModalHeader>View Setup Format</ModalHeader>
                  <ModalCloseButton />
                  <ModalBody>
                     {Array.isArray(viewSetupFormat) && viewSetupFormat.length > 0 ? (
                        viewSetupFormat.map((format, index) => (
                           <Box
                              key={index}
                              border="1px solid #e2e8f0"
                              p={4}
                              borderRadius="md"
                              mb={3}
                              position="relative">
                              <Flex justify="space-between" align="start">
                                 <Box>
                                    <Text>
                                       <strong>Print Invoice Name:</strong> {format.name}
                                    </Text>
                                    <Text>
                                       <strong>Function Name:</strong> {format.functionname}
                                    </Text>
                                    <Text>
                                       <strong>Status:</strong> {format.status ? 'Active' : 'Inactive'}
                                    </Text>
                                    <Text>
                                       <strong>Company:</strong> {format.companyName}
                                    </Text>
                                    <Text>
                                       <strong>Daybook:</strong> {format.daybookName}
                                    </Text>
                                    <Text>
                                       <strong>Created At:</strong> {moment(format.createdat).format('DD/MM/YYYY')}
                                    </Text>
                                    {format.updatedat && (
                                       <Text>
                                          <strong>Updated At:</strong> {moment(format.updatedat).format('DD/MM/YYYY')}
                                       </Text>
                                    )}
                                 </Box>
                                 <IconButton
                                    icon={<DeleteIcon />}
                                    aria-label="Delete format"
                                    size="sm"
                                    colorScheme="red"
                                    onClick={() => handleSetupDelete(format.id)}
                                 />
                              </Flex>
                              <Divider mt={2} />
                           </Box>
                        ))
                     ) : (
                        <Text>No setup formats available.</Text>
                     )}
                  </ModalBody>
                  <ModalFooter>
                     <Button
                        colorScheme="blue"
                        mr={3}
                        onClick={() => {
                           onViewCloseSetupFormatModal();
                           setViewSetupFormat({});
                        }}>
                        Close
                     </Button>
                  </ModalFooter>
               </ModalContent>
            </Modal>

            <Modal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)}>
               <ModalOverlay />
               <ModalContent>
                  <ModalHeader>Duplicate Print Format</ModalHeader>
                  <ModalCloseButton />
                  <ModalBody>
                     <Input
                        placeholder="Enter new name"
                        value={newName}
                        onChange={(e) => {
                           setNewName(e.target.value);
                           if (e.target.value.trim() !== '') setError('');
                        }}
                        isInvalid={!!error}
                     />
                     {error && (
                        <Text color="red.500" mt={2}>
                           {error}
                        </Text>
                     )}
                  </ModalBody>
                  <ModalFooter>
                     <Button colorScheme="blue" onClick={handleSaveDuplicate}>
                        Save
                     </Button>
                  </ModalFooter>
               </ModalContent>
            </Modal>

            <DeleteDialog
               isDeleteDialogOpen={isDeleteDialogOpen}
               setDeleteDialogOpen={setDeleteDialogOpen}
               handleDelete={handleConfirmDelete}
               title="Print Format"
            />
            <DeleteDialog
               isDeleteDialogOpen={isDeleteSetupDialogOpen}
               setDeleteDialogOpen={setDeleteSetupDialogOpen}
               handleDelete={handleConfirmSetupDelete}
               title="Setup Format"
            />
         </div>
      </>
   );
}
